<div class="modal-backdrop">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title || 'USER.MODALS.DELETE.CONFIRM' | translate }}</h4>
      </div>
      <div class="modal-body">
        <p>{{message || 'USER.MODALS.DELETE.MSG' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirm()">{{confirmButton || 'COMMENTS.MODALS.CREATE.YES'| translate }}</button>
        <button type="button" class="btn btn-default" (click)="cancel()">{{closeButton || 'COMMENTS.MODALS.CREATE.CANCEL'| translate }}</button>
      </div>
    </div>
  </div>
</div>
